import React from 'react';
import { BrainIcon, CheckIcon, ClockIcon, CopyIcon, ListChecksIcon, ShieldCheckIcon, SparklesIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from '../components/CtaButton';
import { FaqItem } from '../components/FaqItem';
import { bonuses, faqs, features, formatPillars, heroIncludes, included, moduleTitles, offerChecklist, outcomes, painPoints, stats } from '../data/content';
const EBOOK_COVER_URL = 'https://cdn.magicpatterns.com/uploads/77kVvdUnL1pxrCtCw1HiqK/Mockup_ADHD.png';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/1roViPmDXjaiz1sGkRNVUW/Logo_IG.jpg';
const phases = [{
  label: 'Dump',
  description: 'Get every task and idea out of your head and onto the page.'
}, {
  label: 'Execute',
  description: 'Micro-steps that break paralysis in the first 48 hours.'
}, {
  label: 'Feed',
  description: 'Meals and groceries decided before hunger hits.'
}, {
  label: 'Control',
  description: 'A 3-question filter between you and the impulse buy.'
}, {
  label: 'Recover',
  description: 'Spot the crash early and reset in 72 hours.'
}, {
  label: 'Reset',
  description: '5-minute sprints that keep your home from piling up.'
}];
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-cream font-body text-slate-800" data-id="element-10" data-mp="30tdqh410ek2s">

      {/* Top banner */}
      <header data-id="element-11" data-mp="2vw540r8tvtvq">
        <div className="bg-brand-medium px-4 py-2 text-center text-xs font-bold tracking-wide text-white sm:text-sm" data-id="element-12" data-mp="2vwnbyl4urwjh">
          <span aria-hidden="true" data-id="element-13" data-mp="3tg88zve9n9dm">🧠 </span>Digital download — Instant access after purchase
        </div>
        
      </header>

      <main id="top" data-id="element-14" data-mp="3jjvewwet6tic">

        {/* Hero */}
        <section className="bg-brand-deep px-5 py-8 text-center text-white sm:py-14 lg:py-16" data-id="element-15" data-mp="3jitui1bwkuny">
          <div className="mx-auto max-w-4xl" data-id="element-16" data-mp="3fi9t2lkar4w0">
            <h1 className="font-display text-4xl font-bold leading-[1.08] tracking-tight sm:text-5xl lg:text-7xl" data-id="element-17" data-mp="284zsgo9x7nr8">
              Stop the Mental Chaos.{' '}
              <span className="text-brand-gold" data-id="element-18" data-mp="242ct82ax70k0">Start Executing Today.</span>
            </h1>
            <p className="mx-auto mt-3 max-w-2xl text-base leading-relaxed text-white/85 sm:mt-4 sm:text-xl" data-id="element-19" data-mp="25lctyxtrst7t">
              <strong className="font-black text-white" data-id="element-20" data-mp="2aj4uuhce7po5">The ADHD Brain-Dump &amp; Reset System™.</strong> Your brain dumps everything. Your system does the rest.
            </p>
            <img src={EBOOK_COVER_URL} alt="The ADHD Brain-Dump & Reset System — six modules plus 5 bonuses included" className="mx-auto mt-3 w-full max-w-[280px] bg-transparent object-contain sm:mt-5 sm:max-w-md lg:max-w-lg" data-id="element-21" data-mp="20kfbek4ulx5s" />
            <p className="mt-4 font-display text-3xl font-bold text-brand-gold sm:text-4xl" data-id="element-22" data-mp="1rn53n8r8oq5m">
              Only $19
            </p>
            <div className="mt-4 flex flex-col items-center gap-3 sm:mt-6 sm:flex-row sm:justify-center" data-id="element-23" data-mp="1huz8xr9lrumq">
              <CtaButton label="Get Access Now" target="checkout" data-id="element-24" data-mp="13uy1fsyu1oya" />
              <CtaButton label="See What's Inside" target="inside" variant="outline" className="text-brand-gold" data-id="element-25" data-mp="13xtylf2uw9lo" />
            </div>
            <p className="mt-3 text-xs font-bold tracking-wide text-white/70" data-id="element-26" data-mp="p894nyvytpvl">
              🔒 Secure checkout in your local currency
            </p>

            {/* What you get */}
            <div className="mx-auto mt-8 max-w-2xl text-left sm:mt-10" data-id="element-27" data-mp="y979gje8a1f8">
              <p className="text-center text-sm font-black uppercase tracking-[0.16em] text-brand-gold" data-id="element-28" data-mp="y7coj52yi9b5">
                Here is everything you get
              </p>
              <ul className="mt-4 grid gap-2 sm:grid-cols-2" role="list" data-id="element-29" data-mp="186bvmj82pww1">
                {heroIncludes.map(item => <li key={item} className="flex items-start gap-3 rounded-xl border border-white/10 bg-white/5 px-4 py-3" data-id="element-30" data-mp="137qvskwqhf84">
                    <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-brand-gold" aria-hidden="true" data-id="element-31" data-mp="1h21byduo012k" />
                    <span className="text-[15px] leading-snug text-white/90" data-id="element-32" data-mp="1d0g271dfg2wl">{item}</span>
                  </li>)}
              </ul>

              <p className="mt-7 text-center text-sm font-black uppercase tracking-[0.16em] text-brand-gold" data-id="element-33" data-mp="1lzjp6gfpt2gd">
                The 6 modules inside
              </p>
              <ul className="mt-4 space-y-2" role="list" data-id="element-34" data-mp="25z1rtyzzz9jl">
                {moduleTitles.map(module => <li key={module} className="flex items-start gap-3 border-l-2 border-brand-gold/60 pl-4 text-[15px] leading-snug text-white/90" data-id="element-35" data-mp="2a0wtx5pr5qyf">
                    {module}
                  </li>)}
              </ul>
            </div>
          </div>
        </section>

        {/* Format promise bar */}
        <section aria-label="Format promise" className="bg-[#F1E4CE] px-5 py-4 text-center text-sm font-bold sm:text-base text-brand-deep" data-id="element-36" data-mp="1n43c2vzruyjb">
          <span aria-hidden="true" data-id="element-37" data-mp="1w2f8jenbkqjo">⚡ </span>No motivation required. No guilt trips. Just results — plug-and-play modules you can use today
        </section>

        {/* Pain points */}
        <section id="pain-points" className="bg-brand-cream px-5 py-12 sm:py-16" data-id="element-38" data-mp="37i3uq3sr1ljf">
          <div className="mx-auto max-w-5xl" data-id="element-39" data-mp="37k80yse4ewmv">
            <div className="mx-auto max-w-2xl text-center" data-id="element-40" data-mp="3cgf5cgqvc02p">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-41" data-mp="3cj19s7igpzgp">
                You are not alone
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-42" data-mp="vvtclb8nkk1b">
                Does this sound like you?
              </h2>
            </div>
            <ul className="mt-8 grid gap-4 sm:grid-cols-2 sm:gap-5" role="list" data-id="element-43" data-mp="m5qjzc5g183i">
              {painPoints.map(point => <li key={point.title} className="flex items-start gap-4 rounded-2xl border border-brand-medium/15 bg-white p-5 shadow-sm" data-id="element-44" data-mp="i4eq2ufje0pi">
                  <span className="mt-0.5 text-2xl" aria-hidden="true" data-id="element-45" data-mp="d6daijhbkjis">{point.emoji}</span>
                  <span data-id="element-46" data-mp="85fq008u7de4">
                    <span className="block font-display text-xl font-bold leading-snug text-brand-deep" data-id="element-47" data-mp="364asvo4cfyn">
                      {point.title}
                    </span>
                    <span className="mt-1 block text-base leading-relaxed text-slate-700" data-id="element-48" data-mp="22ifdefjglbvy">
                      {point.text}
                    </span>
                  </span>
                </li>)}
            </ul>
            <blockquote className="mx-auto mt-10 max-w-3xl border-l-4 border-brand-medium pl-5 font-display text-xl font-bold italic leading-relaxed text-brand-deep sm:text-2xl" data-id="element-49" data-mp="3ry9djft1dsta">
              "You do not have a discipline problem. You have a missing operating system for your brain."
            </blockquote>
            <p className="mx-auto mt-5 max-w-3xl text-center text-base leading-relaxed text-slate-600" data-id="element-50" data-mp="3myws8zhtctst">
              Most days start with the same negotiation: what to do first, what to eat, what to clean, what you already forgot. That is not laziness — it is executive function spent on decisions a written system should have made for you.
            </p>
          </div>
        </section>

        {/* Solution */}
        <section id="solution" className="bg-brand-deep px-5 py-12 text-white sm:py-16" data-id="element-51" data-mp="2qb8hx3nzu5jt">
          <div className="mx-auto max-w-3xl text-center" data-id="element-52" data-mp="2uclq3kek6ktw">
            <BrainIcon className="mx-auto h-10 w-10 text-brand-gold" aria-hidden="true" data-id="element-53" data-mp="2ue55l8se4rum" />
            <p className="mt-5 text-sm font-black uppercase tracking-[0.16em] text-brand-gold" data-id="element-54" data-mp="2mrro473atd9m">The solution</p>
            <h2 className="mt-3 font-display text-4xl font-bold leading-tight tracking-tight sm:text-5xl" data-id="element-55" data-mp="2htq2pfieh1uz">
              Introducing The ADHD Brain-Dump &amp; Reset System™
            </h2>
            <div className="mt-5 space-y-4 text-lg leading-relaxed text-white/85" data-id="element-56" data-mp="2rsp207h9zl5b">
              <p data-id="element-57" data-mp="243mlx42ai0cx">
                6 plug-and-play modules + 5 bonus systems designed to turn mental chaos into automatic execution.
              </p>
              <p data-id="element-58" data-mp="1z1ni5t2n11fg">
                <strong className="font-bold text-white" data-id="element-59" data-mp="2ds4krfr0dxdx">No motivation required. No guilt trips.</strong> Just results.
              </p>
            </div>
            <div className="mt-8 grid gap-3 text-left sm:grid-cols-2" data-id="element-60" data-mp="290d17p69srxa">
              {phases.map(phase => <div key={phase.label} className="rounded-xl border border-white/15 bg-white/5 p-4" data-id="element-61" data-mp="1lair3fdc5hgq">
                  <p className="text-sm font-black uppercase tracking-wide text-brand-gold" data-id="element-62" data-mp="1gch4ikgpb00i">{phase.label}</p>
                  <p className="mt-1 text-sm leading-relaxed text-white/80" data-id="element-63" data-mp="uvigtutfeb1z">{phase.description}</p>
                </div>)}
            </div>
          </div>
        </section>

        {/* Format — not a book to read */}
        <section id="format" className="bg-brand-cream px-5 py-12 sm:py-16" data-id="element-64" data-mp="14u7xxldhzrh6">
          <div className="mx-auto max-w-5xl" data-id="element-65" data-mp="18urt4jeigl0o">
            <div className="mx-auto max-w-2xl text-center" data-id="element-66" data-mp="1dt1puyfvvtoe">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-67" data-mp="1dqfjv38n5m8a">
                Zero fluff, 100% actionable
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-68" data-mp="1nje7oiwbd8qu">
                This is not a book you read. It is a system you install.
              </h2>
              <p className="mt-4 text-lg leading-relaxed text-slate-700" data-id="element-69" data-mp="1wk2kxbdvv52o">
                No chapters, no theory, no homework. You open a page, do the one small step on it, and move on.
              </p>
            </div>
            <div className="mt-8 grid gap-4 md:grid-cols-3" data-id="element-70" data-mp="3m1q28kvp9om9">
              {formatPillars.map((pillar, index) => {
              const Icon = [ClockIcon, CopyIcon, ListChecksIcon][index];
              return <article key={pillar.label} className="flex flex-col rounded-2xl border border-brand-medium/15 bg-white p-6 shadow-sm" data-id="element-71" data-mp="3d009nbq30jmw" data-mpi={index}>
                    <Icon className="h-7 w-7 text-brand-medium" aria-hidden="true" data-id="element-72" data-mp="8l8ubj989uag" />
                    <h3 className="mt-4 font-display text-xl font-bold leading-snug text-brand-deep" data-id="element-73" data-mp="8n388dm30m51">
                      {pillar.label}
                    </h3>
                    <p className="mt-2 text-[15px] leading-relaxed text-slate-600" data-id="element-74" data-mp="3vx1g70zaarsy">
                      {pillar.description}
                    </p>
                  </article>;
            })}
            </div>
            <p className="mx-auto mt-8 max-w-2xl rounded-2xl bg-brand-deep px-6 py-4 text-center text-base font-black text-white sm:text-lg" data-id="element-75" data-mp="sasu647c7s6c">
              Brain dump today. Executing tasks within 48 hours.
            </p>
          </div>
        </section>

        {/* The modules */}
        <section id="inside" className="bg-[#EFE1CA] px-5 py-12 sm:py-16" data-id="element-76" data-mp="2wggiogqsk2e9">
          <div className="mx-auto max-w-6xl" data-id="element-77" data-mp="3af6hq1x68c59">
            <div className="mx-auto max-w-2xl text-center" data-id="element-78" data-mp="3ag94bxngnsfd">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-79" data-mp="36c9tnvov3ntx">
                Fill-in-the-blank worksheets, ready to use
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-80" data-mp="3feansjosttrd">
                The 6 Modules of the System
              </h2>
            </div>
            <div className="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-81" data-mp="3p3u6npcihnm8">
              {features.map((feature, index) => <article key={feature.title} className="rounded-2xl border border-brand-medium/15 bg-white p-5 shadow-sm" data-id="element-82" data-mp="6xxypeqpj68y" data-mpi={index}>
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-brand-medium font-display text-lg font-bold text-white" data-id="element-83" data-mp="205zs0rnajv9">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <h3 className="mt-5 font-display text-xl font-bold leading-snug text-brand-deep" data-id="element-84" data-mp="qhwvtjii51e9">
                    {feature.title}
                  </h3>
                  <p className="mt-2 text-xs font-black uppercase tracking-wide text-brand-medium" data-id="element-85" data-mp="gksa1kskj7xz">
                    {feature.pain}
                  </p>
                  <p className="mt-3 text-[15px] leading-relaxed text-slate-600" data-id="element-86" data-mp="7l54qnwpxhzn">
                    {feature.description}
                  </p>
                </article>)}
            </div>
          </div>
        </section>

        {/* What's included */}
        <section id="included" className="bg-brand-cream px-5 py-12 sm:py-16" data-id="element-87" data-mp="3u1hsw8rlrxic">
          <div className="mx-auto max-w-4xl" data-id="element-88" data-mp="3g0ov9f608mb0">
            <div className="mx-auto max-w-2xl text-center" data-id="element-89" data-mp="3g31leflx22z5">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-90" data-mp="3kz053pwauwt8">
                Everything in the package
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-91" data-mp="1lt3648sx67pn">
                What&apos;s Included
              </h2>
            </div>
            <ul className="mt-8 space-y-3" role="list" data-id="element-92" data-mp="1grx93ys87yab">
              {included.map(item => <li key={item.title} className="flex items-start gap-4 border-b border-brand-medium/15 pb-4 last:border-b-0" data-id="element-93" data-mp="1ctzjiuujna6e">
                  <CheckIcon className="mt-1 h-5 w-5 flex-none text-brand-olive" aria-hidden="true" data-id="element-94" data-mp="29gbamoiixcqm" />
                  <span data-id="element-95" data-mp="24hrkebwwdesg">
                    <span className="block font-display text-xl font-bold leading-snug text-brand-deep" data-id="element-96" data-mp="20hhgr5wkv0gr">
                      {item.title}
                    </span>
                    <span className="mt-1 block text-[15px] leading-relaxed text-slate-600" data-id="element-97" data-mp="1vl8vdarseb15">
                      {item.description}
                    </span>
                  </span>
                </li>)}
            </ul>
          </div>
        </section>

        {/* Bonuses */}
        <section id="bonuses" className="bg-[#F6EDDC] px-5 py-12 sm:py-16" data-id="element-98" data-mp="2vsxk5rnc6u22">
          <div className="mx-auto max-w-5xl" data-id="element-99" data-mp="30qz2gacxupch">
            <div className="mx-auto max-w-2xl text-center" data-id="element-100" data-mp="30ntfp1rs7zjx">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-101" data-mp="34q7vfd05mj6z">
                Included at no extra cost
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-102" data-mp="3ehuc3ov9hah4">
                🎁 5 Bonus Systems Included
              </h2>
              <p className="mt-4 text-lg leading-relaxed text-slate-700" data-id="element-103" data-mp="3jii34ajhprbc">
                The extra systems that keep the chaos from coming back.
              </p>
            </div>
            <div className="mt-8 grid gap-4 md:grid-cols-2" data-id="element-104" data-mp="3sgkad7tthg72">
              {bonuses.map(bonus => <article key={bonus.title} className="rounded-r-2xl border-l-4 border-brand-medium bg-white px-5 py-5 shadow-sm sm:px-6" data-id="element-105" data-mp="1u3243nza5lz6">
                  <div className="flex items-start gap-4" data-id="element-106" data-mp="1y55iakdc34o5">
                    <span className="text-3xl" aria-hidden="true" data-id="element-107" data-mp="12rkwn3r7stcp">{bonus.emoji}</span>
                    <div data-id="element-108" data-mp="yqixso17mjb9">
                      <span className="inline-block rounded-full bg-brand-gold px-3 py-1 text-xs font-black uppercase tracking-wide text-brand-deep" data-id="element-109" data-mp="yraszxqwaf10">
                        {bonus.tag}
                      </span>
                      <h3 className="mt-3 font-display text-xl font-bold leading-snug text-brand-deep" data-id="element-110" data-mp="17qfp6xezhwa0">
                        {bonus.title}
                      </h3>
                      <p className="mt-2 text-[15px] leading-relaxed text-slate-600" data-id="element-111" data-mp="f562s03owxz5">
                        {bonus.description}
                      </p>
                    </div>
                  </div>
                </article>)}
            </div>
          </div>
        </section>

        {/* Proof */}
        <section id="proof" className="bg-brand-deep px-5 py-12 text-white sm:py-16" data-id="element-112" data-mp="1alry69rrgso">
          <div className="mx-auto max-w-5xl" data-id="element-113" data-mp="3shojwzxflr3y">
            <div className="mx-auto max-w-2xl text-center" data-id="element-114" data-mp="3sgn4ykdaokgy">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-gold" data-id="element-115" data-mp="27yvx3pmy2kkb">
                Real results. Real people.
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight sm:text-5xl" data-id="element-116" data-mp="1z00raentbchj">
                What changes in the first month
              </h2>
            </div>
            <dl className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-117" data-mp="22yzplgf1gb00">
              {stats.map(stat => <div key={stat.value} className="rounded-2xl border border-white/10 bg-white/5 p-6 text-center" data-id="element-118" data-mp="2qp3vxvjm2oup">
                  <dt className="font-display text-5xl font-bold leading-none text-brand-gold" data-id="element-119" data-mp="2hq8okg4tz8pt">
                    {stat.value}
                  </dt>
                  <dd className="mt-3 text-[15px] leading-relaxed text-white/80" data-id="element-120" data-mp="2mns21dtpfhgp">
                    {stat.label}
                  </dd>
                </div>)}
            </dl>
          </div>
        </section>

        {/* Author */}
        <section id="author" className="bg-brand-cream px-5 py-12 sm:py-16" data-id="element-121" data-mp="1b7tnwvjo658m">
          <div className="mx-auto flex max-w-4xl flex-col items-center gap-7 text-center md:flex-row md:text-left" data-id="element-122" data-mp="3cyke1csbos79">
            <img src={LOGO_URL} alt="Prof. Kyra logo" className="h-40 w-40 flex-none rounded-full border-8 border-white bg-black object-contain shadow-lg" data-id="element-123" data-mp="382c1861llb39" />
            <div data-id="element-124" data-mp="2z6w5fjha8lv1">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-125" data-mp="2z7fjuq7q4s4b">
                Created with care
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-126" data-mp="2pa13eqlsw3c0">
                Meet Prof. Kyra
              </h2>
              <p className="mt-5 text-lg leading-relaxed text-slate-700" data-id="element-127" data-mp="2kay83xvmhbh8">
                Prof. Kyra creates practical, field-tested digital systems designed to solve real everyday problems. Every resource is built to give real tools — not just information.
              </p>
              <p className="mt-4 text-lg leading-relaxed text-slate-700" data-id="element-128" data-mp="ej19kf8aii3s">
                The ADHD Brain-Dump &amp; Reset System™ was created for brains that are full of ideas and out of bandwidth — so execution stops depending on how you feel that day.
              </p>
            </div>
          </div>
        </section>

        {/* Outcomes */}
        <section id="outcomes" className="bg-[#EFE1CA] px-5 py-12 sm:py-16" data-id="element-129" data-mp="2a6q917hdzjtw">
          <div className="mx-auto max-w-4xl text-center" data-id="element-130" data-mp="2a8uazjvq68rj">
            <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-131" data-mp="1dhinw0kojcqi">
              What you will achieve
            </p>
            <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-132" data-mp="1ihoa3186k717">
              After the System
            </h2>
            <p className="mx-auto mt-5 max-w-3xl font-display text-xl font-bold italic leading-relaxed text-brand-deep" data-id="element-133" data-mp="1rhb7lbxsgsoz">
              "Consistency is not a personality trait. It is a system written down once."
            </p>
            <ul className="mt-8 grid gap-4 text-left sm:grid-cols-2" role="list" data-id="element-134" data-mp="32tkhf60xisr0">
              {outcomes.map(outcome => <li key={outcome} className="flex items-start gap-3 rounded-2xl border border-brand-medium/15 bg-white p-5 shadow-sm" data-id="element-135" data-mp="2egqwvdhhzar2">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-brand-olive" aria-hidden="true" data-id="element-136" data-mp="2nbosisc151m3" />
                  <span className="text-base leading-relaxed text-slate-700" data-id="element-137" data-mp="2ijwyg7to0dr7">{outcome}</span>
                </li>)}
            </ul>
          </div>
        </section>

        {/* Offer */}
        <section id="offer" className="bg-brand-deep px-5 py-12 sm:py-16" data-id="element-138" data-mp="2sai7kp6yt0od">
          <div className="mx-auto max-w-xl rounded-3xl bg-white p-7 text-center shadow-2xl sm:p-8" data-id="element-139" data-mp="2scch77csd6d5">
            <SparklesIcon className="mx-auto h-9 w-9 text-brand-medium" aria-hidden="true" data-id="element-140" data-mp="367wxrw51lche" />
            <h2 className="mt-4 font-display text-3xl font-bold text-brand-deep sm:text-4xl" data-id="element-141" data-mp="326bg7xhkca0v">
              Everything You Get Today
            </h2>
            <p className="mt-2 font-display text-2xl font-bold text-brand-deep sm:text-3xl" data-id="element-142" data-mp="17v6itax2kttz">
              The ADHD Brain-Dump &amp; Reset System™
            </p>
            <ul className="mt-7 space-y-3 text-left" role="list" data-id="element-143" data-mp="xsu790leidqz">
              {offerChecklist.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-slate-700" data-id="element-144" data-mp="11tw45aruidps">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-brand-olive" aria-hidden="true" data-id="element-145" data-mp="szrkpcf1k4ka" />
                  <span data-id="element-146" data-mp="e2h27j3zdyf2">{item}</span>
                </li>)}
            </ul>
            <div className="mt-8 flex flex-col items-center border-t border-brand-medium/15 pt-7 text-center" data-id="element-147" data-mp="e4lccish3tns">
              <p className="mt-1 font-display text-5xl font-bold leading-none text-brand-deep" data-id="element-148" data-mp="iz7fxzsbchxb">
                $19
              </p>
              <p className="mt-2 text-sm font-bold text-slate-600" data-id="element-149" data-mp="a03u4o1rhof4">
                One-time payment — Yours forever
              </p>
            </div>
            <p className="mt-6 text-sm font-black text-brand-medium" data-id="element-150" data-mp="1zdqtwgdoubtb">
              ✓ 7-Day Money-Back Guarantee. Full refund, no questions asked.
            </p>
            <CtaButton label="Get the System Now" className="mt-3 w-full" target="checkout" data-id="element-151" data-mp="37y1j8qw8cmnf" />
            <p className="mt-3 text-xs font-bold tracking-wide text-slate-600" data-id="element-152" data-mp="3cqup5i3fq113">
              🔒 Secure checkout in your local currency
            </p>
            <p className="mt-2 text-xs font-bold tracking-wide text-slate-500" data-id="element-153" data-mp="2xz2az9fdmt0y">
              📩 Instant delivery <span aria-hidden="true" data-id="element-154" data-mp="32xn993b2j2mr">|</span> 🛡️ 7-day guarantee
            </p>
          </div>
        </section>

        {/* FAQ */}
        <section id="faq" className="bg-brand-cream px-5 py-12 sm:py-16" data-id="element-155" data-mp="3vox8bg9ax3qz">
          <div className="mx-auto max-w-3xl" data-id="element-156" data-mp="3how5hv9h7m8v">
            <div className="text-center" data-id="element-157" data-mp="3ho4bupzfvyl8">
              <p className="text-sm font-black uppercase tracking-[0.16em] text-brand-medium" data-id="element-158" data-mp="3lqhg19yjfofw">
                Clear answers
              </p>
              <h2 className="mt-3 font-display text-4xl font-bold tracking-tight text-brand-deep sm:text-5xl" data-id="element-159" data-mp="268o0ln6knyu1">
                Frequently Asked Questions
              </h2>
            </div>
            <div className="mt-8 space-y-3" data-id="element-160" data-mp="22r0bw1gudipq">
              {faqs.map(faq => <FaqItem key={faq.question} {...faq} data-id="element-161" data-mp="1xsqgpqv4ai44" />)}
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section id="final-cta" className="bg-brand-deep px-5 py-12 text-center text-white sm:py-16" data-id="element-162" data-mp="2cq92ckci0f7c">
          <div className="mx-auto max-w-3xl" data-id="element-163" data-mp="27qmqofcbj70n">
            <ZapIcon className="mx-auto h-10 w-10 text-brand-gold" aria-hidden="true" data-id="element-164" data-mp="27otfqnuoa0mu" />
            <h2 className="mt-5 font-display text-4xl font-bold tracking-tight sm:text-5xl" data-id="element-165" data-mp="1k1ldkesjj7p1">
              Stop Fighting Your Brain. Start Using It.
            </h2>
            <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-white/85" data-id="element-166" data-mp="1ts6kcpidbij1">
              The ADHD Brain-Dump &amp; Reset System™ is the operating system your mind needs. No more chaos. No more guilt. Just execution.
            </p>
            <p className="mt-5 font-display text-3xl font-bold text-brand-gold sm:text-4xl" data-id="element-167" data-mp="118ps480i3bza">
              $19 <span className="align-middle font-body text-sm font-black uppercase tracking-wide" data-id="element-168" data-mp="w9mydjpz0s6m">One-time payment</span>
            </p>
            <p className="mx-auto mt-4 max-w-2xl text-sm font-bold leading-relaxed text-white/75" data-id="element-169" data-mp="1q0ygnew0jhm4">
              ✓ 7-Day Money-Back Guarantee. If the system doesn&apos;t help you regain clarity and control, you get a full refund. No questions asked.
            </p>
            <CtaButton label="Get the System Now" className="mt-4" target="checkout" data-id="element-170" data-mp="1zt488nicrx0s" />
            <p className="mt-3 text-xs font-bold tracking-wide text-white/70" data-id="element-171" data-mp="132tyjfbspzkn">
              🔒 Secure checkout in your local currency
            </p>
          </div>
        </section>

      </main>

      <footer className="bg-[#2B1D15] px-5 py-10 text-center text-white/70" data-id="element-172" data-mp="1c0dz0m1u3ru7">
        <ShieldCheckIcon className="mx-auto h-6 w-6 text-brand-gold" aria-hidden="true" data-id="element-173" data-mp="1h1l58gobwiyr" />
        <p className="mt-4 text-sm" data-id="element-174" data-mp="2nfswdqxyglpu">© 2026 The ADHD Brain-Dump &amp; Reset System™. All Rights Reserved.</p>
        <nav aria-label="Footer navigation" className="mt-3 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm" data-id="element-175" data-mp="2senltbqfh8ix">
          <a href="#privacy" className="underline-offset-4 hover:text-white hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold" data-id="element-176" data-mp="grtvhu6hgwzz">
            Privacy Policy
          </a>
          <a href="#terms" className="underline-offset-4 hover:text-white hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold" data-id="element-177" data-mp="70z64gxxxhab">
            Terms of Service
          </a>
          <a href="mailto:profkyra@gmail.com" className="underline-offset-4 hover:text-white hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold" data-id="element-178" data-mp="3u5f4p59a9yma">
            Contact
          </a>
        </nav>
        <p className="mx-auto mt-6 max-w-3xl text-xs leading-relaxed text-white/55" data-id="element-179" data-mp="3fahbka6b9545">
          This product is an educational and informational resource. It does not constitute medical, psychological, or financial advice.
        </p>
      </footer>

    </div>;
}